import React, { useEffect, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FaSpinner, FaTimes } from 'react-icons/fa';
import '../index.css';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

function Ticket() {
  const [ticket, setTicket]         = useState(null);
  const [loading, setLoading]       = useState(true);
  const [message, setMessage]       = useState('');
  const [addingWallet, setAddingWallet] = useState(false);
  const [isSafari, setIsSafari]     = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const phone    = searchParams.get('phone');
  const ticketId = searchParams.get('ticketId');

  // 1) detect Safari (iOS or macOS)
  useEffect(() => {
    const ua = navigator.userAgent;
    const safariOnIOS = /iP(ad|hone|od)/.test(ua) && /Safari/.test(ua) && !/Chrome/.test(ua);
    const safariOnMac = /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome/.test(ua);
    setIsSafari(safariOnIOS || safariOnMac);
  }, []);

  // Fetch ticket as before…
  useEffect(() => {
    if (!phone || !ticketId) {
      setMessage('Invalid link: missing ticket information.');
      setLoading(false);
      return;
    }
    (async function getTicket() {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_BASE_AWS_URL}/${process.env.REACT_APP_STAGE}/getTicket`,
          { params:{ phone, ticketID: ticketId } }
        );
        if (resp.status === 200 && resp.data.ticket) {
          setTicket(resp.data.ticket);
        } else {
          setMessage('Failed to retrieve your pass. Contact support.');
        }
      } catch (err) {
        console.error(err);
        setMessage('Error retrieving ticket. Please try again.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // 2) Updated handler: just navigate to your GET URL
  const handleAddToWallet = async () => {
    if (!ticket) return;
    setAddingWallet(true);
  
    try {
      // 1) Fetch the presigned S3 URL
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_AWS_URL}/${process.env.REACT_APP_STAGE}/addToWallet`,
        {
          params: {
            phone:    ticket.phone,
            ticketID: ticket.ticketID
          },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      const { url } = resp.data;  // { url: 'https://…s3…' }
  
      // 2) Open that URL in a new tab -- Safari will fire the Wallet sheet
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error('Add to Wallet failed:', err);
      alert('Could not add to Apple Wallet. Please try again.');
    } finally {
      setAddingWallet(false);
    }
  };  

  const handleClose = () => navigate('/');

  return (
    <div className="modal-overlay">
      <div className="qr-modal">
        <div className="modal-header">
          <FaTimes onClick={handleClose} className="close-icon" />
        </div>

        {loading ? (
          <div className="spinner-wrapper"><FaSpinner className="spinner"/></div>
        ) : message ? (
          <>
            <div className="error-message">{message}</div>
            <button className="button-primary" onClick={handleClose}>
              Return Home
            </button>
          </>
        ) : ticket ? (
          <>
            <p className="modal-title">{ticket.title}</p>
            <div className="qr-code-wrapper">
              <QRCodeCanvas value={JSON.stringify(ticket)} size={300} />
            </div>
            <div className="ticket-details">
              <p><strong>Venue:</strong> {ticket.bar_name}</p>
              <p><strong>Name:</strong> {ticket.name}</p>
              <p>
                <strong>Valid until:</strong>{' '}
                {new Date(ticket.datetime_invalid).toLocaleString()}
              </p>
            </div>

            <div className="button-group">
              {/* only show on Safari */}
              {isSafari && (
                <button
                  className="ios-wallet-button"
                  onClick={handleAddToWallet}
                  disabled={addingWallet}
                >
                  {addingWallet
                    ? <FaSpinner className="spinner"/>
                    : <><img src="/Add_To_Apple_Wallet.png" style={{ width: 150 }} alt='Add to Apple Wallet'/>
                       Add to Apple Wallet</>
                  }
                </button>
              )}

              <button className="button-primary" onClick={handleClose}>
                Close
              </button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default Ticket;